import React from 'react';

interface LinkProps {
	title: string;
	url: string;
	customClass?: string;
	shouldOpenNewTab?: boolean;
	onClick?: () => void;
}

/*
	This is a very general link / anchor tag component, but I found myself
	using `target="_blank"` with `rel="noopener noreferrer"` and having to
	call functions after a link was clicked. This helps to cut down on the
	repetitiveness for both of those tasks.
*/
export default function Link({
	title,
	url,
	customClass = 'link',
	shouldOpenNewTab = true,
	onClick = () => {},
}: LinkProps) {
	return (
		<a
			className={customClass}
			href={url}
			target={shouldOpenNewTab ? '_blank' : undefined}
			rel={shouldOpenNewTab ? 'noopener noreferrer' : undefined}
			onClick={onClick}
		>
			{title}
		</a>
	);
}
